import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_cookieuniversalnuxt_47b74f0e from 'nuxt_plugin_cookieuniversalnuxt_47b74f0e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_1a358934 from 'nuxt_plugin_axios_1a358934' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_elementui_72a9ed1c from 'nuxt_plugin_elementui_72a9ed1c' // Source: ../plugins/element-ui.js (mode: 'client')
import nuxt_plugin_index_0c69654a from 'nuxt_plugin_index_0c69654a' // Source: ../plugins/index.js (mode: 'client')
import nuxt_plugin_router_79dc5b58 from 'nuxt_plugin_router_79dc5b58' // Source: ../plugins/router.js (mode: 'client')
import nuxt_plugin_store_59704eec from 'nuxt_plugin_store_59704eec' // Source: ../plugins/store.js (mode: 'client')
import nuxt_plugin_vueawesomeswiper_5ce03f58 from 'nuxt_plugin_vueawesomeswiper_5ce03f58' // Source: ../plugins/vue-awesome-swiper.js (mode: 'client')
import nuxt_plugin_vuelazyload_e6901296 from 'nuxt_plugin_vuelazyload_e6901296' // Source: ../plugins/vue-lazyload (mode: 'client')
import nuxt_plugin_plugins_0021d0e3 from 'nuxt_plugin_plugins_0021d0e3' // Source: ../packages/plugins (mode: 'all')
import nuxt_plugin_htplugins_ca5cd06e from 'nuxt_plugin_htplugins_ca5cd06e' // Source: ../components/company/package/ht-plugins.js (mode: 'all')
import nuxt_plugin_commonComponents_3663e7c0 from 'nuxt_plugin_commonComponents_3663e7c0' // Source: ../plugins/commonComponents.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_request_e6dd6e04 from 'nuxt_plugin_request_e6dd6e04' // Source: ../plugins/request.js (mode: 'all')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_jquery_e2c6283a from 'nuxt_plugin_jquery_e2c6283a' // Source: ../plugins/jquery.js (mode: 'all')
import nuxt_plugin_myDirective_2d4fe149 from 'nuxt_plugin_myDirective_2d4fe149' // Source: ../plugins/_plugins/myDirective (mode: 'all')
import nuxt_plugin_myLodash_a348464a from 'nuxt_plugin_myLodash_a348464a' // Source: ../plugins/_plugins/myLodash (mode: 'all')
import nuxt_plugin_filters_2f795c41 from 'nuxt_plugin_filters_2f795c41' // Source: ../plugins/_plugins/filters (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"潮国创意_中国原创国潮创意图片设计_正版商用版权素材库","htmlAttrs":{"lang":"zh-CN"},"meta":[{"hid":"description","name":"description","content":"潮国创意是目前国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源的素材图片网站。包含各类潮流前沿、高品质正版原创图片素材,chaopx.com 是值得信懒、可商用的国潮创意潮流设计网站。"},{"hid":"keywords","name":"keywords","content":"潮国创意,中国元素,中国元素素材,潮流创意,创意设计,创意设计网站,原创设计,图片素材,潮流图片,潮流设计,设计图,创意作品"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fchaotu.ico"},{"rel":"stylesheet","href":"\u002F\u002Fat.alicdn.com\u002Ft\u002Fc\u002Ffont_3161803_b7r4aedesm.css"},{"rel":"stylesheet","href":"\u002F\u002Fat.alicdn.com\u002Ft\u002Fc\u002Ffont_3593403_c009ttntn3p.css"},{"rel":"stylesheet","href":"\u002F\u002Fat.alicdn.com\u002Ft\u002Fc\u002Ffont_3548305_5tpcz82dcgh.css"}],"script":[{"src":"https:\u002F\u002Fhm.baidu.com\u002Fhm.js?d7459b4b4edd7825a7efca3d3af32a3c"},{"src":"https:\u002F\u002Fg.alicdn.com\u002FAWSC\u002FAWSC\u002Fawsc.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_cookieuniversalnuxt_47b74f0e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_47b74f0e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_1a358934 === 'function') {
    await nuxt_plugin_axios_1a358934(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_elementui_72a9ed1c === 'function') {
    await nuxt_plugin_elementui_72a9ed1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_0c69654a === 'function') {
    await nuxt_plugin_index_0c69654a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_router_79dc5b58 === 'function') {
    await nuxt_plugin_router_79dc5b58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_store_59704eec === 'function') {
    await nuxt_plugin_store_59704eec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_5ce03f58 === 'function') {
    await nuxt_plugin_vueawesomeswiper_5ce03f58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_e6901296 === 'function') {
    await nuxt_plugin_vuelazyload_e6901296(app.context, inject)
  }

  if (typeof nuxt_plugin_plugins_0021d0e3 === 'function') {
    await nuxt_plugin_plugins_0021d0e3(app.context, inject)
  }

  if (typeof nuxt_plugin_htplugins_ca5cd06e === 'function') {
    await nuxt_plugin_htplugins_ca5cd06e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_commonComponents_3663e7c0 === 'function') {
    await nuxt_plugin_commonComponents_3663e7c0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_request_e6dd6e04 === 'function') {
    await nuxt_plugin_request_e6dd6e04(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (typeof nuxt_plugin_jquery_e2c6283a === 'function') {
    await nuxt_plugin_jquery_e2c6283a(app.context, inject)
  }

  if (typeof nuxt_plugin_myDirective_2d4fe149 === 'function') {
    await nuxt_plugin_myDirective_2d4fe149(app.context, inject)
  }

  if (typeof nuxt_plugin_myLodash_a348464a === 'function') {
    await nuxt_plugin_myLodash_a348464a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2f795c41 === 'function') {
    await nuxt_plugin_filters_2f795c41(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
